angular.module('gym.bulkMessages', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.bulkMessages', {
    abstract: true,
    template: '<ui-view autoscroll="false">'
  }).state('gym.bulkMessages.new', {
    url: '/bulk_messages/new?notice&from&fromContactId&fromContactType&eventId&invoiceId&bulkMessageId',
    controller: 'newBulkMessageCtrl',
    template: require('templates/gyms/bulk_messages/new.html.slim'),
    data: {
      preserveBulkMessage: true
    },
    resolve: {
      templates: ["Templates", function(Templates) {
        var params;
        params = {
          count: 1500,
          'filters[for_general_use]': true
        };
        return Templates.getList(params);
      }],
      reports: ["Reports", function(Reports) {
        return Reports.getList();
      }]
    }
  }).state('gym.bulkMessages.confirm', {
    url: '/bulk_messages/confirm?notice&from&fromContactId&fromContactType&eventId&invoiceId',
    controller: 'confirmBulkMessageCtrl',
    template: require('templates/gyms/bulk_messages/confirm.html.slim'),
    data: {
      preserveBulkMessage: true
    }
  }).state('gym.bulkMessages.sent_messages', {
    url: '/sent_messages',
    template: require('templates/gyms/bulk_messages/sent_messages.html.slim')
  }).state('gym.bulkMessages.smsReplies', {
    url: '/sms_replies',
    template: require('templates/gyms/bulk_messages/sms_replies.html.slim')
  }).state('gym.bulkMessages.list', {
    url: '/bulk_messages',
    template: require('templates/gyms/bulk_messages/list.html.slim')
  }).state('gym.bulkMessages.recipients', {
    url: '/bulk_messages/:bulkMessageId/recipients',
    template: require('templates/gyms/bulk_messages/recipients.html.slim')
  });
}]);
